import { render } from "./base-startup-users-chart.vue?vue&type=template&id=191f0f1d"
import script from "./base-startup-users-chart.vue?vue&type=script&lang=js"
export * from "./base-startup-users-chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__